// extracted by mini-css-extract-plugin
module.exports = {"keyboard":"Keyboard_keyboard__mpmTR"};